import React from "react";
import { AboutContactSettings, toTelHref } from "./menuUtils";

type Props = {
    contact: AboutContactSettings;
};

export function AboutContactBlock({ contact }: Props) {
    const companyName = contact.companyName?.trim() ?? "";
    const address = contact.address?.trim() ?? "";
    const phone = contact.phone?.trim() ?? "";
    const phoneLabel = contact.phoneLabel?.trim() ?? "";
    const email = contact.email?.trim() ?? "";
    const emailLabel = contact.emailLabel?.trim() ?? "";

    const phoneHref = toTelHref(phone);

    return (
        <div className="side-header-menu__group side-header-menu__about-contact">
            {companyName && <p className="side-header-menu__group-heading">{companyName}</p>}
            <div className="side-header-menu__group-links">
                {address && <p className="side-header-menu__about-line">{address}</p>}
                {phone && (
                    <p className="side-header-menu__about-line">
                        {phoneLabel ? `${phoneLabel} ` : ""}
                        <a href={`tel:${phoneHref}`}>{phone}</a>
                    </p>
                )}
                {email && (
                    <p className="side-header-menu__about-line">
                        {emailLabel ? `${emailLabel} ` : ""}
                        <a href={`mailto:${email}`}>{email}</a>
                    </p>
                )}
            </div>
        </div>
    );
}
